export default __webpack_public_path__ + "static/media/rob.ea4e01a5.png";